import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const ratingApi = createApi({
  reducerPath: "ratingApi",
  baseQuery: customFetchBase({ url: "rating" }),
  tagTypes: ["Rating", "Coach", "Gym"],
  endpoints: (builder) => ({
    addRating: builder.mutation({
      query: ({ targetId, data }) => ({
        url: `/${targetId}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result, error, { targetId, data }) => [
        "Rating",
        { type: "Rating", id: `${data?.targetType}-${targetId}` },
        data?.targetType === "Coach" ? "Coach" : "Gym",
      ],
    }),

    deleteMyRating: builder.mutation({
      query: ({ targetId, data }) => ({
        url: `/${targetId}`,
        method: "DELETE",
        body: data,
      }),
      invalidatesTags: (result, error, { targetId, data }) => [
        "Rating",
        { type: "Rating", id: `${data?.targetType}-${targetId}` },
        data?.targetType === "Coach" ? "Coach" : "Gym",
      ],
    }),

    getCoachRating: builder.query({
      query: (coachId) => ({
        url: `/coach/${coachId}`,
        method: "GET",
      }),
      providesTags: (result, error, coachId) => [
        "Rating",
        { type: "Rating", id: `Coach-${coachId}` },
      ],
    }),

    getGymRating: builder.query({
      query: (gymId) => ({
        url: `/gym/${gymId}`,
        method: "GET",
      }),
      providesTags: (result, error, gymId) => [
        "Rating",
        { type: "Rating", id: `Gym-${gymId}` },
      ],
    }),

    getMyCoachRating: builder.query({
      query: (coachId) => ({
        url: `/me/coach/${coachId}`,
        method: "GET",
      }),
      providesTags: (result, error, coachId) => [
        "Rating",
        { type: "Rating", id: `Coach-${coachId}` },
      ],
    }),

    getMyGymRating: builder.query({
      query: (gymId) => ({
        url: `/me/gym/${gymId}`,
        method: "GET",
      }),
      providesTags: (result, error, gymId) => [
        "Rating",
        { type: "Rating", id: `Gym-${gymId}` },
      ],
    }),
  }),
});

export const {
  useAddRatingMutation,
  useDeleteMyRatingMutation,
  useGetCoachRatingQuery,
  useGetGymRatingQuery,
  useGetMyCoachRatingQuery,
  useGetMyGymRatingQuery,
} = ratingApi;
